import React, { useState } from 'react'
import { toast } from 'react-toastify'
import UpdateDynamicListStatusService from '../../Services/Mutations/UpdateDynamicListStatusService'
import { ToastStyle } from '../Data/MovieStaticData'

function DynamicListBulkActions(props) {
  const { checkedArray, setStateValue, dynamicLists, status } = props
  const [selectedValue, setselectedValue] = useState('')
  const applyFunction = () => {
    // setLoadSpinner(true)
    const dynamicListsTemp = [...dynamicLists]

    // let listMovieCollectionsTempeory = []
    checkedArray.map(async item => {
      const response = await UpdateDynamicListStatusService({
        dynamicListID: item.dynamicListID,
        status: selectedValue,
      })
      if (response.statusCode === 'M022' || response.statusCode === 'M023') {
        toast.success(response.statusMessage, ToastStyle)
      }
    })
    const remainingElements =
      dynamicListsTemp &&
      dynamicListsTemp.filter(elem => !checkedArray.find(element => elem.SK === element.SK))
      setStateValue('dynamicLists', remainingElements)
    // setLoadSpinner(false)
    setStateValue('checkedArray', [])
  }

  const HandleSelectedValue = e => {
    setselectedValue(e.target.value)
  }

  return (
    <>
      {checkedArray.length > 0 ? (
        <div style={{ marginTop: '3px' }}>
          <label style={{ marginTop: '7px' }} htmlFor='languages'>
            Bulk Actions:
          </label>
          <select
            onChange={HandleSelectedValue}
            required
            value={selectedValue}
            name='select'
            id='languages'
            className='form-control'
            style={{ width: '25%' }}
          >
            <option value='' disabled selected>
              Bulk Actions{' '}
            </option>

            <option name='chechboxdelete' value='deleted'>
              Delete
            </option>
            {status === 'draft' && (
              <option name='chechboxdelete' value='published'>
                Approve
              </option>
            )}
          </select>
          <button onClick={applyFunction} className='m-1 btn btn-primary'>
            Apply{' '}
          </button>
        </div>
      ) : (
        <>
          <label style={{ marginTop: '7px' }} className='languages'>
            Bulk Actions:
          </label>
          <select
            disabled
            name='select'
            id='languages'
            className='form-control'
            style={{ width: '25%' }}
          >
            {' '}
            <option value='' disabled selected>
              Bulk Actions{' '}
            </option>
          </select>
          <button disabled onClick={applyFunction} className='m-1 btn btn-primary'>
            Apply{' '}
          </button>
        </>
      )}
    </>
  )
}

export default DynamicListBulkActions
